import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function postSirenaQuotes(leadId, sirenaHeader) {
  const response = await axios.post(`${REACT_APP_API}/sirena/quotes/${leadId}`, sirenaHeader)
  return response
}